export default __webpack_public_path__ + "static/sample-email-ee58fd0b4f49c1ff2766801864366fd2.png";